// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/javascript/src/styles/app.scss
// module id = 11
// module chunks = 0